/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable class-methods-use-this */
/* eslint-disable block-scoped-var */
/* eslint-disable no-var */
/* eslint-disable no-eval */
/* eslint-disable no-restricted-syntax */
import LayerConfig from "./LayerConfig";

/* eslint-disable camelcase */
export default class LayerConfigQgis {
    layer: LayerConfig;
    elTagLayerTreeGroup: any;
    elProjectlayers: any;

    constructor(layer: LayerConfig, elTagLayerTreeGroup: any, elProjectlayers: any) {
        this.layer = layer;
        this.elTagLayerTreeGroup = elTagLayerTreeGroup;
        this.elProjectlayers = elProjectlayers;
    }

    getUid() {
        return this.layer.uid;
    }

    getLayername() {
      return this.layer.layername;
    }

    getName() {
      return this.layer.title;
    }

    getType() {
        return this.layer.type;
    }

    getSrs() {
      return {
        srsid: '3857',
        srid: '3857',
        authid: 'EPSG:3857',
      };
    }

    getUrl() {
      return this.layer.url;
    }

    getOutputFormat() {
      return this.layer.outputFormat;
    }

    getLayerSource() {
      return this.layer.getOlLayer().getSource();
  }

    isVisible() {
      return this.layer.isVisible();
    }

    getCheckedValue(bValue: boolean) {
      return bValue ? 'Qt::Checked' : 'Qt::Unchecked';
    }

    toQgis() {
      switch(this.getType()) {
        case 'WMS':
          this.wmsToQgis();
          break;
        case 'WMTS':
          this.wmtsToQgis();
          break;
        case 'WFS':
          this.wfsToQgis();
          break;
      }
    }

    wfsToQgis() {
      this.elTagLayerTreeGroup.ele('layer-tree-layer', {
        source : this.getSourceWfs(),
        providerKey : 'WFS',
        id : this.getUid(),
        checked : this.getCheckedValue(this.isVisible()),
        name : this.getName(),
      });

      this.wfsMaplayerToQgis();

    }

    getSourceWfs() {
      const oUrl = new URL(this.getUrl());

      const oSource = [{
        key : 'srsname',
        value : this.getSrs().authid
      },{
        key : 'typename',
        value : this.getLayername()
      },{
        key : 'url',
        value : `${oUrl.origin}${oUrl.pathname}`
      },{
        key : 'url',
        value : `${oUrl.origin}${oUrl.pathname}?version=${oUrl.searchParams.get('version')}`
      }]

      return oSource.map(src => `${src.key}='${src.value}'`).join(" ");
    }

    wfsMaplayerToQgis() {
      const elmaplayer = this.elProjectlayers.ele('maplayer', {type: 'vector'});
      elmaplayer.ele('id').txt(this.getUid());
      elmaplayer.ele('datasource').txt(this.getSourceWfs());
      elmaplayer.ele('layername').txt(this.getName());

      this.addSrsElement(elmaplayer);

      elmaplayer.ele('provider', {encoding : ''}).txt('WFS');
    }

    wmsToQgis() {
      this.elTagLayerTreeGroup.ele('layer-tree-layer', {
        source : this.getSourceWms(),
        providerKey : 'wms',
        id : this.getUid(),
        checked : this.getCheckedValue(this.isVisible()),
        name : this.getName(),
      });
      this.wmsMaplayerToQgis();
    }

    getSourceWms() {
      const oLayerSource = this.getLayerSource();
      const oURLSearchParams = new URLSearchParams();
      if(! oLayerSource) {
        return oURLSearchParams.toString();
      }

      const oLayerSourceParams = oLayerSource.getParams();
      oURLSearchParams.append('crs', this.getSrs().authid);
      oURLSearchParams.append('format', this.getOutputFormat() ?? 'image/png');
      oURLSearchParams.append('layers', this.getLayername());
      oURLSearchParams.append('styles', oLayerSourceParams['STYLES'] ?? '');
      oURLSearchParams.append('url', this.getUrl());
      return oURLSearchParams.toString();
    }

    wmsMaplayerToQgis() {
      const elmaplayer = this.elProjectlayers.ele('maplayer', {type: 'raster'});
      elmaplayer.ele('id').txt(this.getUid());
      elmaplayer.ele('datasource').txt(this.getSourceWms());
      elmaplayer.ele('layername').txt(this.getName());

      this.addSrsElement(elmaplayer);

      elmaplayer.ele('provider').txt('wms');
    }

    wmtsToQgis() {
      this.elTagLayerTreeGroup.ele('layer-tree-layer', {
        source : this.getSourceWmts() ?? "",
        providerKey : 'wms',
        id : this.getUid(),
        checked : this.getCheckedValue(this.isVisible()),
        name : this.getName(),
      });
      this.wmtsMaplayerToQgis();
    }

    getSourceWmts() {
      const oLayerSource = this.getLayerSource();
      const oURLSearchParams = new URLSearchParams();
      if(! oLayerSource) {
        return oURLSearchParams.toString();
      }

      oURLSearchParams.append('crs', this.getSrs().authid);
      oURLSearchParams.append('format', oLayerSource.getFormat() ?? 'image/png');
      oURLSearchParams.append('layers', this.getLayername());
      oURLSearchParams.append('styles', oLayerSource.getStyle());
      oURLSearchParams.append('tileMatrixSet', oLayerSource.getMatrixSet());
      oURLSearchParams.append('url', this.getUrl());
      return oURLSearchParams.toString();
    }

    wmtsMaplayerToQgis() {
      const elmaplayer = this.elProjectlayers.ele('maplayer', {type: 'raster'});
      elmaplayer.ele('id').txt(this.getUid());
      elmaplayer.ele('datasource').txt(this.getSourceWmts());
      elmaplayer.ele('layername').txt(this.getName());

      this.addSrsElement(elmaplayer);

      elmaplayer.ele('provider').txt('wms');
    }

    addSrsElement(elParent: any) {
      const {srid, srsid, authid} = this.getSrs();
      const elsrs = elParent.ele('srs');
      const elspatialrefsys = elsrs.ele('spatialrefsys')
      elspatialrefsys.ele('srsid').txt(srsid)
      elspatialrefsys.ele('srid').txt(srid)
      elspatialrefsys.ele('authid').txt(authid)
    }
}